import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';
import { IMemberList, IDepartmentList } from '@umu/umu-types';
import { IDepartListParam } from './interface';
import { DEPARTMENT_ACCESS } from '@umu/umu-types';

export interface ISubDepartListInfo {
    department_id: string;
    member_count: string;
    department_name: string;
    parent_department_id: string;
    enterprise_show_name?: string;
    managers: IMemberList[];
    child_path: IDepartmentList[];
    parent_path: IDepartmentList[];
}

export const getSubDepartmentList = (data: IDepartListParam): Promise<ISubDepartListInfo> => {
    if (data.type === DEPARTMENT_ACCESS.ADMIN) {
        delete data.type;
    }
    return fetchData(Api.GET_SUB_DEPARTMENT_LIST, data).then((res: IResponse<ISubDepartListInfo>) => {
        return res.data;
    });
};
